import Skill from '@/components/Skill';
import { SKILL_LIST } from '../index.js';
export default {
  components: {
    Skill
  },
  data() {
    return {
      skillList: SKILL_LIST
    };
  }
};